import Axios from 'axios';
var RejectStockInOrderService = (function () {
    function RejectStockInOrderService() {
    }
    RejectStockInOrderService.prototype.getList = function (params) {
        return Axios.get('supplierclientapi/reject_stock_in_order/list', { params: params });
    };
    RejectStockInOrderService.prototype.getListGoods = function (params) {
        return Axios.get('supplierclientapi/reject_stock_in_order/list_goods', { params: params });
    };
    RejectStockInOrderService.prototype.audit = function (params) {
        return Axios.get('supplierclientapi/reject_stock_in_order/audit', { params: params });
    };
    RejectStockInOrderService.prototype.discard = function (params) {
        return Axios.get('supplierclientapi/reject_stock_in_order/cancel', { params: params });
    };
    RejectStockInOrderService.prototype.reject = function (params) {
        return Axios.post('supplierclientapi/reject_stock_in_order/reject', params);
    };
    RejectStockInOrderService.prototype.getDetail = function (params) {
        return Axios.get('supplierclientapi/reject_stock_in_order/detail', { params: params });
    };
    RejectStockInOrderService.prototype.update = function (params) {
        return Axios.post('supplierclientapi/reject_stock_in_order/update', params);
    };
    RejectStockInOrderService.createInstance = function () {
        RejectStockInOrderService.getInstance();
    };
    RejectStockInOrderService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return RejectStockInOrderService;
}());
export default RejectStockInOrderService;
